import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useDisableLlmClient = () => {
  const {
    data: isDisabled,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const disableLlmClient = async (llmName: string, id: string) => {
    await call(`/admin/llm/${llmName}/clients/${id}/enable`, "DELETE");
  };

  return {
    disableLlmClient,
    isDisabled,
    isLoading,
    isFailed,
  };
};
